import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Textarea from '@mui/joy/Textarea'
import { debounce } from 'lodash'

const DEBOUNCE_MS = 100
export const CaptionFieldV2 = ({ value, disabled, onChange }) => {
    const handleCaptionChange = (e) => {
        onChange(e.target.value)
    }

    return (
        <>
            <FormControl>
                <FormLabel>Caption</FormLabel>
                <Textarea
                    disabled={disabled}
                    minRows={8}
                    maxRows={10}
                    defaultValue={value}
                    onChange={debounce(handleCaptionChange, DEBOUNCE_MS)}
                />
            </FormControl>
        </>
    )
}
